import React from "react";
import { Bell, ChevronLeft, MapPin } from "lucide-react";
import { ForestLogo } from "./ForestLogo";
type GovHeaderProps = {
  title: string;
  subtitle?: string;
  back?: () => void;
  onNotifications?: () => void;
  compact?: boolean;
};
export function GovHeader({
  title,
  subtitle,
  back,
  onNotifications,
  compact = false
}: GovHeaderProps) {
  return <header className={compact ? "px-5 pt-5 pb-3" : "px-5 pt-6 pb-4"} data-id="element-110" data-mp="se4ucbntzvvs">
    <div className="flex items-center justify-between" data-id="element-111" data-mp="xavb717gmvi9">
      <div className="flex min-w-0 items-center gap-3" data-id="element-112" data-mp="12azs2sca5s90">
        {back ? <button onClick={back} aria-label="পেছনে যান" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-[#176B3A] shadow-sm ring-1 ring-[#dbe9df]" data-id="element-113" data-mp="129exx3tvobbo"><ChevronLeft size={22} data-id="element-114" data-mp="1bzrgwrm1nwfp" /></button> : <ForestLogo size="sm" data-id="element-115" data-mp="1c2vrc6q3roet" />}
        <div className="min-w-0" data-id="element-116" data-mp="1g2o28q2yy6nc"><h1 className="truncate text-[17px] font-bold leading-tight text-[#1F2D24]" data-id="element-117" data-mp="1g35z9oxggowb">{title}</h1>{subtitle && <p className="mt-1 flex items-center gap-1 truncate text-xs text-[#69776E]" data-id="element-118" data-mp="1l0piz4cx9tvn"><MapPin size={12} data-id="element-119" data-mp="1qja3ykd6ltiv" />{subtitle}</p>}</div>
      </div>
      {onNotifications && <button onClick={onNotifications} aria-label="নোটিফিকেশন" className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-white text-[#176B3A] shadow-sm ring-1 ring-[#dbe9df]" data-id="element-120" data-mp="1qh73t7ibek0f"><Bell size={20} data-id="element-121" data-mp="1hky3zrqfdjdr" /><span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-[#C62828] ring-2 ring-white" data-id="element-122" data-mp="1cjquno8mwc4z" /></button>}
    </div>
  </header>;
}